<template>
  <div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible">
      <el-row class="content-row content-remark" v-if="type !== 'waitAccept'">
        <el-col :span="4" style="padding-top:5px"><i v-if="handleType === '03'" style="color:#C8102D;font-weight:700;margin-right:3px">*</i>{{handleType === '03' ? '填写驳回理由' : '填写审批建议'}}</el-col>
        <el-col :span="19">
          <el-input type="textarea" v-model="approvalFormData.processRemark" :placeholder="handleType === '03' ? '请填写驳回理由' : '请填写审批建议'" style="width: 550px"></el-input>
        </el-col>
      </el-row>
      <el-row v-else class="content-row" style="text-align: center; font-size: 16px">是否确认收货？</el-row>
      <div style="margin-top:10px;" v-if="showAcceptTip">注意：店招物料类提报验收成功后将触发PR审批和PO创建流程。</div>

      <div slot="footer" class="dialog-footer">
        <el-button class="btn-red-plain" size="small" @click="dialogClose">取 消</el-button>
        <el-button class="btn-red" size="small" :loading="btnLoading" @click="handleConfirm">确认{{ dialogTitle }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'singal-dialog',
  props: {
    approvalFormData: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      dialogTitle: '',
      dialogVisible: false,
      handleType: '',
      type: '',
      applyId: '',
      applyType: '',
      btnLoading: false,
      showAcceptTip:false
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    dialogShow (handleType, type, id, applyType) {
      if (handleType === '03') {
        this.dialogTitle = '驳回'
      } else {
        if (type === 'waitCheck') { 
          this.dialogTitle = '验收'  
          this.showAcceptTip = true
        }
        if (type === 'waitAccept') this.dialogTitle = '收货'
      }
      this.handleType = handleType
      this.type = type
      this.applyId = id
      this.applyType = applyType

      this.dialogVisible = true
    },

    dialogClose () {
      this.dialogVisible = false
      this.showAcceptTip = false
    },

    // 弹窗确认
    handleConfirm () {
      
      if (this.btnLoading) {
        return
      }

      let successText = ''
      let params = {}

      // 驳回
      if (this.handleType === '03') {
        if (!this.approvalFormData.processRemark) {
          this.$message.error('请填写驳回理由')
          return
        }
        successText = '验收驳回成功'
        params = {
          applyId: this.applyId,
          approvalResult: '03', // 01提交，02审批通过，03审批退回
          approvalType: '03', // 01需求审批 02费用审批 03验收审批
          processClientId: this.userInfo.clientId,
          processClientName: this.userInfo.clientName,
          processRemark: this.approvalFormData.processRemark
        }
      } else {
        // 通过
        if (this.type === 'waitCheck') {
          successText = '确认验收成功'
          params = {
            applyId: this.applyId,
            approvalResult: '02', // 01提交，02审批通过，03审批退回
            approvalType: '03', // 01需求审批 02费用审批 03验收审批
            processClientId: this.userInfo.clientId,
            processClientName: this.userInfo.clientName,
            processRemark: this.approvalFormData.processRemark
          }
        } else {
          successText = '确认收货成功'
          params = {
            applyId: this.applyId
          }
          this.btnLoading = true
          this.$store.dispatch('handleReceipt', params).then(res => {
            this.btnLoading = false
            if (res.data.resultCode === '0') {
              this.$message.success(successText)
              this.$emit('handleSuccess')
              this.dialogClose()
            }
          }).catch(() => {
            this.btnLoading = false
          })
          return
        }
      }

      if (this.applyType === '03') {
        // isp
        this.btnLoading = true
        this.$store.dispatch('handleIspApprove', params).then(res => {
          this.btnLoading = false
          if (res.data.resultCode === '0') {
            this.$message.success(successText)
            this.$emit('handleSuccess')
            this.dialogClose()
          }
        }).catch(() => {
          this.btnLoading = false
        })
      } else {
        // 百威
        this.btnLoading = true
        this.$store.dispatch('handleApprove', params).then(res => {
          this.btnLoading = false
          if (res.data.resultCode === '0') {
            this.$message.success(successText)
            this.$emit('handleSuccess')
            this.dialogClose()
          }
        }).catch(() => {
          this.btnLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-remark {
  line-height: 20px;
}
::v-deep .el-dialog{
    min-width: 700px;
}
</style>
<style>

</style>
